import React from 'react'
import { CalendarCheck } from 'lucide-react'
import toast from 'react-hot-toast'

import { TASK_VIEW } from 'src/constants'
import Button from 'src/components/shared/button'
import { useTask } from 'src/hooks/useTask'

import { ViewType } from '..'

type Props = {
    setOpen: (isOpen: boolean) => void
    setView: (value: ViewType) => void
    workerPlanId?:string
    workerId?: string
    payload?:Object
}

const ManualTaskComplete: React.FC<Props> = ({ workerPlanId, setOpen,workerId, setView,payload}) => {

    const {loading, taskFn:onCompleteTaskFn}= useTask()

    const onCompleteTask = async() => {
       try{
         await onCompleteTaskFn({path:`workers/${workerId}/tasks/${workerPlanId}/start-complete`,payload:payload!});
        setView(TASK_VIEW.info) 
        setOpen(false);
       }catch(error){
        toast.error('Oops! There was an error completing the task. Please try again.!');
       }
    }

    return (
        <div className='flex flex-col justify-between min-h-[100px]'>
            <div className='flex flex-col items-center'>
                <p className='font-semibold'>Confirm task as completed</p>
                <CalendarCheck className='text-neutral-300 py-3' size={70} />
            </div>
            <Button
              disabled={loading}
                onClick={onCompleteTask}>
                {loading?"Processing...":"Confirm Now"}
            </Button>
        </div>
    )
}

export default ManualTaskComplete
